import { render, staticRenderFns } from "./signContract.vue?vue&type=template&id=54b46936&scoped=true&"
import script from "./signContract.vue?vue&type=script&lang=js&"
export * from "./signContract.vue?vue&type=script&lang=js&"
import style0 from "./signContract.vue?vue&type=style&index=0&id=54b46936&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b46936",
  null
  
)

export default component.exports